/**
 * Meta Pixel helpers for campaign-optimizable events.
 *
 * The pixel snippet itself is injected outside this repo (platform-level), so
 * every call here must tolerate `window.fbq` being absent — in dev, in SSR, and
 * for visitors with tracking blocked.
 *
 * Account creation is handled separately by `fireMetaCompleteRegistration` in
 * `src/hooks/useAuth.tsx`; this module covers the funnel events around it.
 */

const isPixelReady = () => typeof window !== "undefined" && typeof window.fbq === "function";

/** Landing-page view — used as the top-of-funnel signal for paid campaigns. */
export function fireMetaViewContent(contentName: string) {
  if (!isPixelReady()) return;
  try {
    window.fbq!("track", "ViewContent", { content_name: contentName });
  } catch {
    // Never let analytics break a render.
  }
}

/**
 * A completed Stack run — the real conversion we want Meta to optimize toward,
 * reported with the estimated assistance total as the event value.
 */
export function fireMetaStackRun(params: { zip: string; totalEstimated: number }) {
  if (!isPixelReady()) return;
  try {
    window.fbq!("trackCustom", "StackRun", {
      content_name: "Grant Stack run",
      zip: params.zip,
      value: Math.round(params.totalEstimated || 0),
      currency: "USD",
    });
  } catch {
    // Never let analytics break the results UI.
  }
}
